<!--
  crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]
-->
<app-formulario #ctrl URL="pago" titulo="Pagos" [dato]="dato"></app-formulario>

<!-- Menu principal " -->
<app-sistema-menu></app-sistema-menu>

<form name="form" novalidate >
  <div class="contenedor columns " style=" overflow-y:auto; overflow-x: hidden; height:94vh;">
    <!-- apartado de movimientos_articulos -->
    <div class="column is-one-third " style="padding:0em; width: 78%; ">
      <div style="background: #FFF; border-radius: 1em; ">
        <section class="hero is-primary" style="position: fixed; z-index: 12; width: 77.27%;">
          <div class="hero-body">
            <nav class="level ">
              <!-- Left side -->
              <div class="level-left ">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                      <i class="icon-edit-1"></i>
                    </span>
                    Buscar alumnos
                  </p>
                </div>
              </div>
              <div class="level-right " style=" width: 78%; ">
                <div class="level-item" style=" width: 100%; ">
                  <div class="control has-icons-left is-expanded" *ngIf="!codigo_barras_activo" style=" width: 100%; ">
                    <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)"
                      [list-formatter]="autocompleListFormatter" [close-on-focusout]="false" id="buscarArticulo" value-property-name="id"
                      display-property-name="id" path-to-data="" loading-text="Cargando..."
                      no-match-found-text="No hay resultados." (valueChanged)="select_articulo_autocomplete($event)"
                      min-chars="3" class="input is-success is-medium" type="text"
                      placeholder="Escribe el nombre del alumno, o la matrícula" />
                    <span class="icon is-medium is-left">
                      <i class="icon-search3"></i>
                    </span>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="cargando">
          <br />
          <span class="tag is-primary is-large ">
            <span class="icon"> <i class="icon-worldwide fa-spin"></i> </span>
            &nbsp; <span>Cargando...</span>
          </span>
        </div>
        <br><br><br><br>
        <div style="padding: 0.6em;" class="pagos">
          <a id=""></a>
          <div class="notification is-danger" *ngIf="error_venta">
            ¡No se completo el pago! <strong>Intente de nuevo</strong>, Si no
            contacte con soporte
          </div>
          <div class="notification is-warning" *ngIf="seleccione_colegiatura != ''">{{seleccione_colegiatura}}</div>
          <div class="notification is-success" *ngIf="venta_ok">
            Pago realizado con exito <strong>Puede seguir agrenado más</strong>
          </div>
          <div class="notification is-black" *ngIf="sin_resultado != ''">
            ¡Mesaje del servidor! <strong>{{ sin_resultado }}</strong>
          </div>

          <div class="notification is-info" *ngIf="alumnos.saldo_cuenta > 0">
            ¡Este alumno tiene saldo a favor! <strong>Para este pago primero seleccione el concepto de pago y despues de click
              en el saldo para agregar al cobro</strong>
          </div>


          <div class="box" *ngIf="alumnos.nombre != ''">
            <article class="media">
              <div class="media-left">
                <figure class="image is-64x64">
                  <img [src]="
                              alumnos.alumnos_metadatos.foto != '' && alumnos.alumnos_metadatos.foto != null
                                ? ctrl.API_PATH +
                                  '/adjunto/alumnos/' +
                                  alumnos.alumnos_metadatos.foto
                                : alumnos.alumnos_metadatos.avatar != '' && alumnos.alumnos_metadatos.avatar != null
                                ? alumnos.alumnos_metadatos.avatar
                                : './assets/128x128.png'
                            " alt="Image" />
                </figure>
              </div>
              <div class="media-content">
                <div class="content">
                  <div>
                    <strong> Matricula:</strong> {{ alumnos.matricula }}
                    <strong> Nombre:</strong> {{ alumnos.nombre }}
                    {{ alumnos.apellido_paterno }}
                    {{ alumnos.apellido_materno }}

                    <small>{{ alumnos.email }}</small>


                    <button class="button" type="button" (click)="asignarPagoCuenta()" style="float: right"
                      [disabled]="alumnos.saldo_cuenta <= 0">
                      <i class="icon-money"></i>
                      <span [ngClass]="alumnos.saldo_cuenta > 0 ? 'has-text-success' : 'has-text-black-ter'">
                        &nbsp; Saldo: {{ alumnos.saldo_cuenta | currency: ctrl.configuracion.sucursal.moneda}}
                      </span>
                    </button>

                    <!-- OTROS PAGOS -->
                    <button class="button" type="button" style="float: right"
                      (click)="ctrl.abrirModal('otros-pagos'); asignarPersona();">
                      <i class="fa fa-money"></i>
                      &nbsp; Otros pagos
                    </button>

                    <a id="asignarPersona" (click)="ctrlOPF.asignarPersona(alumnos.id);"></a>
                    <a id="traerFactura" (click)="cargar_factura(false, ctrlOPF.devolverFactura())"></a>
                    <div class="modal" id="otros-pagos" *ngIf="alumnos.alumnos_metadatos.nombre != ''">
                      <div class="modal-background"></div>
                      <div class="modal-card" style="width: 96vw;height: 96vh;">
                        <header class="modal-card-head">
                          <p class="modal-card-title"><i class="fa fa-money"></i> Otros Pagos</p>
                          <button id="cerrarOtrosPagos" class="delete" (click)="ctrl.cancelarModal('otros-pagos')"></button>
                        </header>
                        <section class="modal-card-body">
                          <div class="tabs is-boxed">
                            <ul>
                              <li [ngClass]="{ 'is-active' : tab == 1}">
                                <a (click)="tab=1">
                                  <span class="icon is-small is-right">
                                    <i class="icon-file"></i>
                                  </span>
                                  <span>Nuevo</span>
                                </a>
                              </li>

                              <li [ngClass]="{ 'is-active' : tab == 2}">
                                <a (click)="tab=2">
                                  <span class="icon is-small is-right">
                                    <i class="fa fa-dollar"></i>
                                  </span>
                                  <span>Lista</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div [ngClass]="{ 'is-hidden': tab != 1}">
                            
                            <app-otros-pagos-formulario #ctrlOPF persona="{{alumnos.id}}"></app-otros-pagos-formulario>
                          </div>
                          <div [ngClass]="{ 'is-hidden': tab != 2}">
                            <a (click)="ctrlOPL.asignarPersona(alumnos.id, ctrl.dato,alumnos);" class="button navbar-item  is-success tooltip" >
                              <i class="fa fa-search"></i>
                               CARGAR LISTA
                            </a>
                            <app-otros-pagos-lista #ctrlOPL></app-otros-pagos-lista>
                          </div>
                        </section>
                      </div>
                    </div>

                    <!-- FIN OTROS PAGOS-->

                    <br />
                    <strong> Carrera Plan:</strong> {{alumnos.carrera_plan.nombre}}
                    <strong> Carrera:</strong> {{ alumnos.carreras.nombre }}
                    <br />
                    <strong> Modalidad:</strong> {{ alumnos.modalidades.nombre }}
                    <strong> Grupo:</strong> {{ alumnos.grupos.clave }}
                    <strong> Nivel:</strong> {{ alumnos.grupos.nivel }} {{ alumnos.grupos.identificador }}

                    <button class="button" type="button" style="float: right" disabled>
                      <i class="icon-money"></i>
                      <span [ngClass]="alumnos.becas ? 'has-text-success' : 'has-text-danger'">
                        &nbsp; <strong> Beca:</strong> {{ alumnos.becas ? alumnos.becas.becas ? alumnos.becas.becas.nombre : "Sin beca" : "Sin beca" }}
                      </span>
                    </button>

                  </div>
                </div>
              </div>
            </article>
          </div>

          <div class="notification is-danger" *ngIf="alumnos.baja" aling="center">
            Este alumno fue dado de <strong>BAJA</strong>
          </div>

          <div class="box" *ngIf="alumnos.debe_materia">
            <article class="media" style=" width: 100%; border-radius: 5px" >
              <div style=" width: 100%; border-radius: 5px">
                <div class="content">
                  <div class="notification is-success"  aling="center" *ngFor="let item of alumnos.repeticiones_materias; let i = index">
                    Este alumno debe la materia: {{ item.materias.nombre }}

                    <button class="button" type="button" style="float: right" (click)="pagar_materia(item, '93d2c2c286b56ec96c46b7aff5c7c7a8')">
                      <i class="icon-money"></i>
                      <span >
                        &nbsp; <strong> Pagar: {{ item.materias_costos.costo | currency: ctrl.configuracion.sucursal.moneda }}</strong> 
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div >
            <div class="box" *ngFor="let item of inscripciones; let i = index">
              <article class="media" style=" width: 100%; border-radius: 5px" >
                <div style=" width: 100%; border-radius: 5px">
                  <div class="content">
                    <div class="tile is-ancestor">
                      <div class="tile is-parent">
                        <article class="tile is-child box notification" [ngClass]="item.invalidado ? 'is-dark' : 'is-blank'">
                          <div class="content">
                            <p class="title">{{ tipo[item.tipo] }} <span *ngIf="item.invalidado" style="color: red">BAJA</span></p>
                            <p class="subtitle">
                              {{ item.fecha_pago | formatoFecha }}
                            </p>
                            <span class="tag is-black">Grupo: {{ item.grupos.clave }}</span>
                            <span class="tag is-link">Nivel: {{ item.nivel }} {{ item.grupos.identificador }}</span>
                            <span class="tag is-warning is-fullwidth" style="width: 98%;" *ngIf="item.recargo > 0">
                              {{ item.recargo | currency: ctrl.configuracion.sucursal.moneda }}
                            </span>
                            <span class="tag is-success is-small" style=" font-size: 7.8pt; ">{{
                                      item.grupos.periodos_escolares.nombre }}</span>
                            <span class="tag" [style.background]="item.recargos.color" *ngIf="!item.pagado &&item.dias > 0">
                              {{ item.dias }}
                              días</span>
                            <a class="tag button" [style.background-color]="item.pago_completado ? 'green' : 'red'"
                              style="color:white;     float: right;" (click)="mostrarAbonos(item, i, 1)">
                              <span class="icon ">
                                {{ item.movimientos_inscripciones?.length }}
                              </span>
                            </a>
                            <span class="tag is-info">{{ item.importe | currency: ctrl.configuracion.sucursal.moneda }}</span>
                            <div class="content" *ngIf="item.pagado && item.pago_completado">
                              <button class="button is-fullwidth" [ngClass]="
                                          item.movimientos.pago_muerto ? 'is-info' : ''
                                        " type="button" (click)="mostrarAbonos(item, i, 1)">
                                <i class="icon-printer2"></i> &nbsp;Ver Pago
                                <span class="icon ">
                                  ({{ item.movimientos_inscripciones?.length }})
                                </span>
                              </button>
                            </div>

                            <div class="content" *ngIf="!item.pago_completado && i < 1">
                              <a class="button is-fullwidth" style="background:red; color: white"
                                href="#/servicio-financiero/inscripcion/editar/{{item.id}}">
                                <i class="icon-eye2"></i> &nbsp;Pago no completo
                              </a>
                            </div>

                            <div class="content" *ngIf="!item.pagado || !item.pago_completado">

                              <div class="modal" id="cambiar_fecha_insc{{i}}">
                                <div class="modal-background"></div>
                                <div class="modal-card">
                                  <header class="modal-card-head">
                                    <p class="modal-card-title"><i class="fa fa-calendar"></i> Fecha</p>
                                    <button class="delete" (click)="ctrl.cancelarModal('cambiar_fecha_insc'+i)"></button>
                                  </header>
                                  <section class="modal-card-body">
                                    <div class="content">
                                      <h1>¿El pago se hizo en otra fecha?</h1>
                                      <p>
                                        Si es así entonces cambie la fecha, de lo contrario dejar en blanco
                                        <input type="date" class="input" [(ngModel)]="item.created_at"
                                          (change)="asignar_fecha($event, item)" [ngModelOptions]="{standalone: true}">
                                      </p>
                                    </div>
                                  </section>
                                  <footer class="modal-card-foot">
                                    <a class="button is-danger"
                                      (click)="limpiar_fecha(item, i, null); ctrl.cancelarModal('cambiar_fecha_insc'+i)">Limpiar</a>
                                    <a class="button"
                                      (click)="recalcular_dias(item, i, null); ctrl.cancelarModal('cambiar_fecha_insc'+i)">Ok</a>
                                  </footer>
                                </div>
                              </div>

                              <button title="Cambiar fecha captura" *ngIf="!item.agregado && permisos.indexOf(controlador + '.cambio_fecha_pago') > -1"
                                style="font-size:14px; float:left; width:20%" class="button" title="Cambiar fecha captura"
                                type="button" (click)="ctrl.abrirModal('cambiar_fecha_insc'+i)">
                                <i class="icon-calendar"></i>
                              </button> 

                              <button *ngIf="!item.agregado" style="font-size:14px; float:left; width:80%" class="button"
                                type="button"
                                (click)="agregar_articulos(item, tipo[item.tipo] == 'Inscripción' ? 'db61c2cb92dde2df6e62b4b0744f9dce' :'83dae74b6269ce625f4babc3fa613be2')">
                                <i class="icon-money3"></i>Pagar
                              </button>

                              <button *ngIf="item.agregado" style="font-size:14px;" class="button " type="button" (click)="
                                          quitar_articulos(
                                            ctrl.dato.controls.movimientos_articulos,
                                            item,
                                            i
                                          )
                                        ">
                                <i class="icon-trash"></i>Quitar
                              </button>
                            </div>
                          </div>
                        </article>
                      </div>
                      <div class="tile is-vertical is-9" style="overflow: auto;">
                        <div class="tile">
                          <div class="tile is-parent" *ngFor="let val of item.colegiaturas; let pos = index">
                            <article class=" tile is-child notification" style=" width: 100%; padding: 10px; "
                              [ngClass]="item.invalidado || val.movimientos.pago_muerto ? 'is-dark' : (val.pagado && val.pago_completado) || val.agregado == 1 ? 'is-success' : val.dias > dias_pago_normal_colegiatura ? 'is-danger' : ''">
                              <p class="subtitle" [ngClass]="
                                          val.movimientos.pago_muerto
                                            ? 'has-text-grey-light'
                                            : val.pagado == 1 || val.agregado == 1
                                            ? 'has-text-white'
                                            : val.dias > dias_pago_normal_colegiatura
                                            ? 'has-text-white'
                                            : 'has-text-link'
                                        ">
                                <i class="fa fa-calendar"></i> &nbsp;#
                                {{ val.numero_mensualidad }}
                              </p>
                              <div class="fa has-text-black">
                                {{ val.fecha_pago }}
                              </div>
                              <div class="content" *ngIf="val.pago_completado">
                                <button style="font-size:16px;" class="button is-fullwidth" type="button"
                                  (click)="mostrarAbonos(val, pos, 2)">
                                  <i class="icon-printer2"></i>&nbsp;
                                  <span>
                                    Ver ({{ val.movimientos_colegiaturas?.length }})
                                  </span>
                                </button>
                              </div>
                              <div class="content" *ngIf="!val.pagado || !val.pago_completado">
                                <span class="tag" [style.background]="val.recargos.color" *ngIf="val.dias > 0">
                                  {{ val.dias }} días
                                </span>

                                <a class="tag button" [style.background-color]="val.pago_completado ? 'green' : 'red'"
                                  style="color:white;     float: right;" (click)="mostrarAbonos(val, pos, 2)">
                                  <span class="icon ">
                                    {{ val.movimientos_colegiaturas?.length }}
                                  </span>
                                </a>
                                <div>
                                  <span class="tag is-info is-fullwidth"
                                    style="width: 98%;">{{ val.importe | currency: ctrl.configuracion.sucursal.moneda }}</span>
                                  <span class="tag is-warning is-fullwidth" style="width: 98%;" *ngIf="val.recargo > 0">
                                    {{ val.recargo | currency: ctrl.configuracion.sucursal.moneda }}
                                  </span>
                                </div>
                                <button style="font-size:14px; float:left; width:20%" *ngIf="!val.agregado && permisos.indexOf(controlador + '.cambio_fecha_pago') > -1" class="button"
                                  [ngClass]="val.created_at != '' && val.created_at  ? 'is-success' : ''"
                                  title="Cambiar fecha captura" type="button"
                                  (click)="ctrl.abrirModal('cambiar_fecha_col'+i+'-'+pos)" >
                                  <i class="icon-calendar"></i>
                                </button>

                                <div class="modal" id="cambiar_fecha_col{{i}}-{{pos}}">
                                  <div class="modal-background"></div>
                                  <div class="modal-card">
                                    <header class="modal-card-head">
                                      <p class="modal-card-title"><i class="fa fa-calendar"></i> Fecha</p>
                                      <button class="delete"
                                        (click)="ctrl.cancelarModal('cambiar_fecha_col'+i+'-'+pos)"></button>
                                    </header>
                                    <section class="modal-card-body">
                                      <div class="content">
                                        <h1>¿El pago se hizo en otra fecha?</h1>
                                        <p>
                                          Si es así entonces cambie la fecha, de lo contrario dejar en blanco
                                          <input type="date" class="input" [(ngModel)]="val.created_at"
                                            (change)="asignar_fecha($event, val)" [ngModelOptions]="{standalone: true}">
                                        </p>
                                      </div>
                                    </section>
                                    <footer class="modal-card-foot">
                                      <a class="button is-danger"
                                        (click)="limpiar_fecha(val, i, pos); ctrl.cancelarModal('cambiar_fecha_col'+i+'-'+pos)">Limpiar</a>
                                      <a class="button"
                                        (click)="recalcular_dias(val, i, pos); ctrl.cancelarModal('cambiar_fecha_col'+i+'-'+pos)">Ok</a>
                                    </footer>
                                  </div>
                                </div>

                                <button *ngIf="!val.agregado" [disabled]="
                                            pos == 0
                                              ? false
                                              : item.colegiaturas[pos - 1].agregado ||
                                                item.colegiaturas[pos - 1].pagado == 1
                                              ? false
                                              : true
                                          " style="font-size:14px; float:left; width:80%" class="button" type="button"
                                  (click)="agregar_articulos(val, '12a00afca32cafa9f493f73f2b7f8bcf')">
                                  <i class="icon-money3"></i>Pagar
                                </button>

                                <button *ngIf="val.agregado" style="font-size:14px; " class="button is-fullwidth" type="button"
                                  (click)="
                                            quitar_articulos_colegiatura(
                                              ctrl.dato.controls.movimientos_articulos,
                                              item.colegiaturas,
                                              val,
                                              pos
                                            )
                                          ">
                                  <i class="icon-trash"></i>Quitar
                                </button>
                              </div>
                            </article>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- datos del cliente y los importes -->
    <div class="column is-one-third " style="padding:0em; width: 22%; ">
      <div style="background: #FFF; border-radius: 1em; ">
        <section class="hero is-primary" style="position: fixed; z-index: 12; width: 21.79%; height: 47px;">
          <div class="hero-head">
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <p class="title is-4" style=" padding-left: 10px; ">
                    <span *ngIf="ctrl.cargando || cargando" class="icon is-medium">
                      <i class="icon-worldwide fa-spin"></i>
                    </span>
                  </p>
                </div>
              </div>

              <!-- Right side -->
              <div class="level-right">
                <a class="navbar-item is-primary tooltip" (click)="ctrl.abrirModal('pagosPublicos')">
                  <span class="icon fa-2x"> <i class="icon-search3"> </i> </span>
                  <span class="tooltiptext">Pagos publicos</span>
                </a>

                <a class="navbar-item is-primary tooltip" (click)="ctrl.abrirModal('detalleTicket')">
                  <span class="icon fa-2x"> <i class="icon-eye2"> </i> </span>
                  <span class="tooltiptext">Ver</span>
                </a>

                <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x"> <i class="icon-back"> </i> </span>
                  <span class="tooltiptext">Regresar</span>
                </a>

                <a class="navbar-item is-primary tooltip" (click)="cargarDatos(alumnos.id)" id="cargar_datos_actualizar"
                  *ngIf="alumnos.id != ''">
                  <span class="icon fa-2x">
                    <i class="icon-worldwide"></i>
                  </span>
                  <span class="tooltiptext">Actualizar</span>
                </a>

                <a class="navbar-item is-primary tooltip" routerLink="{{url_nuevo}}" *ngIf="ctrl.id">
                  <span class="icon fa-2x"> <i class="icon-file"></i> </span>
                  <span class="tooltiptext">Nuevo</span>
                </a>

                <button class="navbar-item  tooltip" type="button" (click)="imprimir()" *ngIf="reimprimir">
                  <span class="icon fa-2x has-text-info">
                    <i class="icon-printer2"> </i>
                  </span>
                  <span class="tooltiptext">Reimprimir el ticket</span>
                </button>

                <button class="navbar-item  tooltip" type="button" (click)="abrir_facturacion();" *ngIf="ctrl.dato.get('pagos_publicos_id').value == '' && ctrl.dato.get('pagos_cuentas').value == 0">
                  <span class="icon fa-2x has-text-info">
                    <i class="icon-invoice"> </i>
                  </span>
                  <span class="tooltiptext">Facturación</span>
                </button>

                <button class="navbar-item  tooltip" type="button" [ngClass]="{ 'is-loading': cargando }" [disabled]="ctrl.dato.invalid || cargando"
                  *ngIf="!tieneid" (click)="ctrl.abrirModal('confirmarLiquidacion')">
                  <span class="icon fa-2x has-text-success">
                    <i class="icon-diskette"> </i>
                  </span>
                  <span class="tooltiptext">Guardar</span>
                </button>
                <span class="navbar-item"></span>
              </div>
            </nav>
          </div>
        </section>

        <div style="padding: 0em;" [formGroup]="dato">
          <!--
            cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api
          -->
          <br><br>
          <div class="card">
            <header class="card-header">
              <div class="card-header-title">
                Datos del pago
              </div>
              <a class="card-header-icon">
                <span class="icon fa-2x"> <i class="icon-money3"></i> </span>
              </a>
            </header>
            <div class="card-content" style="padding: 0px">
              <a id="catalogos" (click)="
                            ctrl.cargarCatalogo('cuentas_bancarias', 'cuenta-bancaria');
                            ctrl.cargarCatalogo('catalogos_usos_cfdis', ctrl.CFDI_PATH + '/api/v1/catalogo-uso-cfdi');
                            ctrl.cargarCatalogo('clientes', 'cliente?id=1');
                            ctrl.cargarCatalogo('metodos_pagos', 'tipo-metodo-pago');
                            ctrl.cargarCatalogo('formas_pagos', 'tipo-forma-pago');
                            ctrl.cargarCatalogo('cajas', 'caja-operacion?status=1');
                            ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
              <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

              <button class="button is-primary" *ngFor="let cupon of cupones" type="button" (click)="asignar_cupon(cupon, 1)"
                [disabled]="this.dato.controls.personas_cupones_id.value">
                Descuento {{ cupon.importe | currency: ctrl.configuracion.sucursal.moneda }}
              </button>

              <div class="notification is-warning" *ngIf="!caja_abierta && ctrl.configuracion.sucursal.notificar_caja_cerrada ">
                ¡No se ha detectado ninguna caja abierta!
                <strong>Puede realizar el pago</strong>, Pero se recomienda que se
                abra la caja o seleccione una si hay abierta
                <a *ngIf="!tieneid" class="button is-small" routerLink="../../caja-operacion/nuevo">Abrir una caja</a>
                <a *ngIf="tieneid" class="button is-small" routerLink="../../../caja-operacion/nuevo">Abrir una caja</a>
              </div>
              <div class="columns" *ngIf="!caja_abierta">
                <div class="column is-12">
                  <div class="field">
                    <label class="label">Caja:</label>
                    <div class="select" style="float:right">
                      <select class="select" formControlName="cajas_id">
                        <option value="">Ninguna</option>
                        <option *ngFor="let val of ctrl.cajas" value="{{val.id}}">{{ val.cajas.nombre }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns" *ngIf="ctrl.dato.get('pagos_publicos_id').value == ''">
                <div class="column is-12">
                  <div class="field">
                    <div class="b-checkbox is-info">
                      <input id="requiere_factura" class="styled" type="checkbox" formControlName="requiere_factura"
                        [checked]="ctrl.dato.get('requiere_factura').value" />
                      <label for="requiere_factura"> Requiere factura? </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns" *ngIf="ctrl.dato.get('requiere_factura').value == 1">
                <div class="column is-12">
                  <div class="field">
                    <label class="label">Uso CFDI:</label>
                    <div class="select" style="float:right">
                      <select class="select" formControlName="uso_cfdi">
                        <option *ngFor="let item of ctrl.catalogos_usos_cfdis" value="{{item.clave}}">{{ item.nombre }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="columns" *ngIf="ctrl.dato.get('requiere_factura').value == 1">
                <div class="column is-12">
                  <button class="button is-primary" type="button" (click)="ctrl.abrirModal('cambiar_rfc')">
                    Cambiar RFC {{ alumnos.factura_rfc.rfc }}
                  </button>
                </div>
              </div>

              <div class="columns" *ngIf="ctrl.dato.get('requiere_factura').value == 2">
                <div class="column is-12">
                  <div class="field">
                    <div class="b-checkbox is-info">
                      <input id="factura_pendiente" class="styled" type="checkbox" formControlName="pendiente_factura"
                        [checked]="ctrl.dato.get('pendiente_factura').value" />
                      <label for="factura_pendiente"> Dejar pendiente </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <div class="field">
                  <label class="label">Cuenta bancaria:</label>
                  <div class="control has-icons-left has-icons-right">
                    <div class="select">
                      <select class="select" formControlName="cuentas_bancarias_id">
                        <option value="">Seleccione</option>
                        <option *ngFor="let item of ctrl.cuentas_bancarias" value="{{item.id}}">Banco: {{item.banco.nombre }} Clabe:
                          {{item.clabe}} - No. Cuenta:
                          {{item.no_cuenta}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div formArrayName="pagos">
                <div class="content" *ngFor="
                    let item of ctrl.dato.controls.pagos.controls;
                    let i = index
                  ">
                  <div [formGroupName]="i" [style.background]="item.value.es_abono ? 'gainsboro' : ''">
                    <article class="media">
                      <div class="media-content">
                        <div style="display:flow-root">
                          <strong *ngIf="item.value.es_abono" style="float:left">
                            ABONO DE PEDIDO
                          </strong>
                        </div>
                        <div class="columns"><br>
                          <div class="column is-12">
                            <label>Forma de pago: </label>
                            <div class="select">
                              <select class="select" name="tipos_formas_pagos_id" formControlName="tipos_formas_pagos_id" (change)="validar_cantidad_pago(
                                    $event,
                                    ctrl.dato.controls.pagos.controls[i]
                                      .controls.paga_con,
                                    ctrl.dato.get('pagos').value[i].importe,
                                    'min',
                                    i
                                  )">
                                <option *ngFor="let val of ctrl.formas_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                              </select>
                            </div>
                          </div>

                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <label>Comentarios: </label>
                            <textarea class="textarea" rows="3" formControlName="comentarios" maxlength="350"></textarea>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <label>TOTAL A PAGAR: </label>
                            <p class="control has-icons-left has-icons-right">
                              <span class="input has-text-centered is-success" style="background: green;  font-size: 1.5em;  color: white;">
                                {{ ctrl.dato.get('pagos').value[i].importe | currency: ctrl.configuracion.sucursal.moneda }}
                              </span>

                              <span class="icon is-small is-right" *ngIf="!item.controls.importe.valid">
                                <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="!item.controls.importe.valid">Este campo es requerido.</span>
                            </p>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <label>Paga con: </label>
                            <p class="control has-icons-left has-icons-right" *ngIf="!item.value.es_abono">
                              <input class="input has-text-centered is-warning" (keyup)="
                                  validar_cantidad_pago(
                                    $event,
                                    ctrl.dato.controls.pagos.controls[i]
                                      .controls.paga_con,
                                    ctrl.dato.get('pagos').value[i].importe,
                                    'min',
                                    i
                                  )
                                "
                                type="number" step="0.1"  placeholder="{{ alumnos.saldo_cuenta > 0 ? 'Seleccione el saldo' : 'Paga con'}}"
                                formControlName="paga_con" [readonly]="ctrl.dato.get('pagos_publicos_id').value != '' || ctrl.dato.get('pagos_cuentas').value > 0 || alumnos.saldo_cuenta > 0" />
                                <button *ngIf="ctrl.dato.get('pagos_publicos_id').value != ''" class="button is-danger is-fullwidth" (click)="quitarPagosPublicos()" >
                                  <i class="icon-trash"></i>Quitar pago publico
                                </button>
                                <button *ngIf="ctrl.dato.get('pagos_cuentas').value > 0" class="button is-danger is-fullwidth" (click)="quitarPagoCuenta()">
                                  <i class="icon-trash"></i>Quitar pago con cuenta
                                </button>
                            </p>
                            <p class="control has-icons-left has-icons-right" *ngIf="item.value.es_abono">
                              <input class="input has-text-centered is-warning" type="text" placeholder="Paga con"
                                formControlName="paga_con" readonly />
                            </p>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <label>Cambio: </label>
                            <p class="control has-icons-left has-icons-right">
                              <span class="input has-text-centered is-dark" >{{ ctrl.dato.get("cambio").value | currency: ctrl.configuracion.sucursal.moneda }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-12">
                            <label>Metodo de pago: </label>
                            <div class="select">
                              <select class="select" name="tipos_metodos_pagos_id" formControlName="tipos_metodos_pagos_id">
                                <option *ngFor="let val of ctrl.metodos_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              <div class="column is-12" *ngIf="ctrl.dato.get('cambio').value > 0">
                <div class="field">
                  <div class="b-checkbox is-info">
                    <input id="devolucion_cambio" class="styled" type="checkbox" formControlName="devolucion_cambio" [checked]="ctrl.dato.get('devolucion_cambio').value" />
                    <label for="devolucion_cambio"> Se devolverá el cambio? </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <nav class="panel" style="font-size:1em">
            <p class="panel-heading">Desglose de descuentos</p>
            <a class="panel-block" *ngIf="importe_cupon > 0" style=" color: #3b7de0; ">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Desc. Autorizado:</div>
                <div class="column is-6">
                  {{
                  importe_cupon | currency: ctrl.configuracion.sucursal.moneda
                  }}
                  <button class="button is-danger is-small" type="button" (click)="asignar_cupon(null, 0)" style=" float: right; ">
                    <span class="icon-trash"></span>
                  </button>
                </div>
              </div>
            </a>
            <a class="panel-block" style=" color: #3b7de0; ">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Beca:</div>
                <div class="column is-6">
                  {{
                  ctrl.dato.get("descuento").value - importe_cupon
                  | currency: ctrl.configuracion.sucursal.moneda
                  }}
                </div>
              </div>
            </a>
          </nav>

          <nav class="panel" style="font-size:1em">
            <p class="panel-heading">Cobro</p>

            <a class="panel-block is-active">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Subtotal:</div>
                <div class="column is-6">
                  {{
                  ctrl.dato.get("subtotal").value
                  | currency: ctrl.configuracion.sucursal.moneda
                  }}
                </div>
              </div>
            </a>
            <a class="panel-block" *ngIf="ctrl.dato.get('descuento').value > 0" style=" color: red; ">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Descuentos:</div>
                <div class="column is-6">
                  {{
                  ctrl.dato.get("descuento").value
                  | currency: ctrl.configuracion.sucursal.moneda
                  }}
                </div>
              </div>
            </a>
            <a class="panel-block" *ngIf="ctrl.dato.get('iva').value > 0">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Iva:</div>
                <div class="column is-6">
                  {{
                  ctrl.dato.get("iva").value
                  | currency: ctrl.configuracion.sucursal.moneda
                  }}
                </div>
              </div>
            </a>
            <a class="panel-block">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Total:</div>
                <div class="column is-6">
                  {{
                  ctrl.dato.get("total").value
                  | currency: ctrl.configuracion.sucursal.moneda
                  }}

                  <span *ngFor="
                      let moneda of ctrl.configuracion.sucursal
                        .conversiones_monedas
                    "
                    class="tag">
                    <strong>
                      <font>{{ moneda.nombre }}</font>
                    </strong>
                    <font>
                      {{
                      ctrl.dato.get("total").value / moneda.tipo_cambio
                      | currency: ctrl.configuracion.sucursal.moneda
                      }}
                    </font>
                  </span>
                </div>
              </div>
            </a>
            <a class="panel-block" *ngIf="ctrl.dato.get('total_recibido').value > 0">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Total recibido:</div>
                <div class="column is-6">
                  {{
                  ctrl.dato.get("total_recibido").value
                  | currency: ctrl.configuracion.sucursal.moneda
                  }}
                </div>
              </div>
            </a>
            <a class="panel-block" *ngIf="ctrl.dato.get('cambio').value > 0">
              <span class="panel-icon"> <i class="icon-money3"></i> </span>
              <div class="columns" style="width:100%">
                <div class="column is-6">Cambio:</div>
                <div class="column is-6">
                  {{ ctrl.dato.get("cambio").value | currency: ctrl.configuracion.sucursal.moneda }}

                  <span *ngFor="
                      let moneda of ctrl.configuracion.sucursal
                        .conversiones_monedas
                    "
                    class="tag">
                    <strong>
                      <font>{{ moneda.nombre }}</font>
                    </strong>
                    <font>
                      {{
                      ctrl.dato.get("cambio").value / moneda.tipo_cambio
                      | currency: ctrl.configuracion.sucursal.moneda
                      }}
                    </font>
                  </span>
                </div>
              </div>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </div>
</form>


<!--
  colas si se guarda local hacer click despues de gaurdar para quitar el elemento de la lista si se guarda con crud es en automatico
-->
<a (click)="ctrl.quitar_elemento_cola()" id="quitar_cola"></a>
<div class="modal" id="ventas_colas" *ngIf="ctrl.venta?.length > 0">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:45%">
    <header class="modal-card-head">
      <h1>Lista de colas</h1>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <div class="field has-addons">
          <div class="control has-icons-left is-expanded">
            <input type="text" class="input is-flat is-medium" placeholder="Buscar" [(ngModel)]="busqueda" id="search-box" [ngModelOptions]="{standalone: true}"/>
            <span class="icon is-medium is-left">
              <i class="icon-search3"></i>
            </span>
          </div>
          <p class="control">
            <button class="button is-medium is-primary" [ngClass]="{ 'is-disabled': busqueda == '' }" (click)="busqueda = ''">
              <span class="icon"> <i class="fa fa-close"></i> </span>
            </button>
          </p>
        </div>
        <table class="table is-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Cliente</th>
              <th>Comentario</th>
              <th>Importe</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let item of (ctrl.venta | buscar: busqueda);
                let i = index
              ">
              <td>{{ i + 1 }}</td>
              <td>
                <select class="select" style=" border: none; background: transparent; " disabled>
                  <option *ngFor="let pre of ctrl.clientes; let p = index" value="{{pre.id}}" [selected]="pre.id == item.personas_id">
                    {{ pre.nombre }}
                  </option>
                </select>
              </td>
              <td>{{ item.comentario }}</td>
              <td>
                {{ item.total | currency: ctrl.configuracion.sucursal.moneda }}
              </td>
              <td>
                <a title="Surtir" class="button is-success" (click)="ctrl.cargar_lista_colas(i, 'ventas_colas')">
                  <span class="icon"> <i class="fa fa-check"></i> </span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('ventas_colas')" id="ventas_colas">Cerrar Ventana</a>
    </footer>
  </div>
</div>

<div class="modal" id="confirmarLiquidacion">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarLiquidacion')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de generar el pago?</h1>
        <p>Ya no se podra editar la información una vez guardada</p>

        <nav class="panel" style="font-size:1.5em">
          <p class="panel-heading">
            Pago:
            {{
            ctrl.dato.get("requiere_factura").value == 1
            ? "Factura requirida"
            : "No requiere factura"
            }}
          </p>

          <a class="panel-block is-active">
            <span class="panel-icon"> <i class="icon-money3"></i> </span>
            <div class="columns" style="width:100%">
              <div class="column is-6">Subtotal:</div>
              <div class="column is-6">
                {{
                ctrl.dato.get("subtotal").value
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </div>
            </div>
          </a>
          <a class="panel-block" *ngIf="ctrl.dato.get('descuento').value > 0">
            <span class="panel-icon"> <i class="icon-money3"></i> </span>
            <div class="columns" style="width:100%">
              <div class="column is-6">Descuento:</div>
              <div class="column is-6">
                {{
                ctrl.dato.get("descuento").value
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </div>
            </div>
          </a>
          <a class="panel-block" *ngIf="ctrl.dato.get('iva').value > 0">
            <span class="panel-icon"> <i class="icon-money3"></i> </span>
            <div class="columns" style="width:100%">
              <div class="column is-6">Iva:</div>
              <div class="column is-6">
                {{
                ctrl.dato.get("iva").value
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </div>
            </div>
          </a>
          <a class="panel-block">
            <span class="panel-icon"> <i class="icon-money3"></i> </span>
            <div class="columns" style="width:100%">
              <div class="column is-6">Total:</div>
              <div class="column is-6">
                {{
                ctrl.dato.get("total").value
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </div>
            </div>
          </a>
          <a class="panel-block" *ngIf="ctrl.dato.get('total_recibido').value > 0">
            <span class="panel-icon"> <i class="icon-money3"></i> </span>
            <div class="columns" style="width:100%">
              <div class="column is-6">Total recibido:</div>
              <div class="column is-6">
                {{
                ctrl.dato.get("total_recibido").value
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </div>
            </div>
          </a>
          <a class="panel-block" *ngIf="ctrl.dato.get('cambio').value > 0">
            <span class="panel-icon"> <i class="icon-money3"></i> </span>
            <div class="columns" style="width:100%">
              <div class="column is-6">Cambio:</div>
              <div class="column is-6">
                {{ ctrl.dato.get("cambio").value | currency: ctrl.configuracion.sucursal.moneda }}
              </div>
            </div>
          </a>
        </nav>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="enviar()" [ngClass]="{ 'is-loading': borrarCargando }">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarLiquidacion')">Cerrar Ventana</a>
    </footer>
  </div>
</div>

<div class="modal" id="pagosPublicos">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:75%">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-check"></i> Buscar pagos publicos
      </p>
      <button class="delete" (click)="ctrl.cancelarModal('pagosPublicos')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <div class="field is-grouped">
          <div class="control has-icons-left is-expanded">
            <input type="text" class="input is-flat is-medium" placeholder="Buscar" #searchBox id="search-box" (keyup)="listarBusqueda(searchBox.value)">
            <span class="icon is-medium is-left">
              <i class="icon-search3"></i>
            </span>
          </div>
        </div>
        <div class="notification is-warning" *ngIf="seleccione_colegiatura != ''">{{seleccione_colegiatura}}</div>
        <table class="table is-striped  is-fullwidth" >
          <thead>
            <tr>
              <th># </th>
              <th>Banco</th>
              <th>Fecha</th>
              <th>Sucursal </th>
              <th>Importe</th>
              <th>Facturado</th>
              <th>Reclamado por</th>
              <th>Observaciones</th>
              <th width="1%" class="no_pdf">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pagos_publicos; let i=index">
              <td style="vertical-align: middle;">{{i+1}} </td>
              <th style="vertical-align: middle;">{{ item.cuentas_bancarias ? item.cuentas_bancarias.banco?.nombre : '' }}
                (Cuenta: {{ item.cuentas_bancarias?.no_cuenta }}) </th>
              <td style="vertical-align: middle;">{{ item.fecha }} : {{ item.hora }}</td>
              <td style="vertical-align: middle;">{{ item.sucursal }}</td>
              <td style="vertical-align: middle;">{{ item.cantidad | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}
              </td>
              <td style="vertical-align: middle;">{{ item.facturas_id ? 'Si' : 'No' }} </td>
              <td style="vertical-align: middle;">{{ item.personas_id ? persona.nombre : 'Nadie' }} </td>
              <td style="vertical-align: middle;">{{ item.observaciones }}</td>
              <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                <div class="level-left">
                  <a class="navbar-item tooltip" (click)="asignarPagoPublico(item)">
                    <span class="icon fa-2x  has-text-primary">
                      <i class="icon-donation-5"></i>
                    </span>
                    <span class="tooltiptext">Asignar</span>
                  </a>
                </div>
              </td>

            </tr>
            <tr *ngIf="ctrl.dato.length == 0">
              <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
            </tr>
          </tbody>

        </table>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('pagosPublicos')">Cerrar Ventana</a>
    </footer>
  </div>
</div>

<div class="modal" id="detalleTicket">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-check"></i> Articulos en este PAGO
      </p>
      <button class="delete" (click)="ctrl.cancelarModal('detalleTicket')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <table class="table is-striped  is-fullwidth">
          <thead>
            <tr>
              <th>No.</th>
              <th>Nombre</th>
              <th>Precio</th>
              <th>Descuento</th>
              <th>Cantidad</th>
              <th>Importe</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let val of ctrl.dato.get('movimientos_articulos').value;
                let i = index
              ">
              <td>{{ i + 1 }}</td>
              <td>
                {{ val.nombre }} Mes: {{ val.articulos.numero_mensualidad }}
              </td>
              <td>
                {{
                val.precio_unitario
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </td>
              <td>
                {{
                val.descuento | currency: ctrl.configuracion.sucursal.moneda
                }}
              </td>
              <td>{{ val.cantidad }}</td>
              <td>
                {{
                val.precio_con_descuentos
                | currency: ctrl.configuracion.sucursal.moneda
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('detalleTicket')">Cerrar Ventana</a>
    </footer>
  </div>
</div>

<div id="banner" align="center" *ngIf="cargando || ctrl.cargarDatosCatalogo">
  <div class="bloquear-azul"></div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 12999999;  left: 45%;">
    <span class="icon"> <i class="icon-worldwide fa-spin"></i> </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="modal" id="guardado_exito">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-success"></i> Guardado</p>
      <button class="delete" (click)="ctrl.cancelarModal('guardado_exito')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¡Se ha guardado el pago!</h1>
        <p>
          Para imprimir el ticket seleccione uno de los pagos en el boton ver
        </p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('guardado_exito')">Ok</a>
    </footer>
  </div>
</div>


<div class="modal" id="cambiar_rfc">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-credit-card"></i> Seleccione el RFC a utilizar en la facturación</p>
      <button class="delete" (click)="ctrl.cancelarModal('cambiar_rfc')"></button>
    </header>
    <section class="modal-card-body">
      <table class="table is-striped  is-fullwidth">
        <thead>
          <tr>
            <th># </th>
            <th>RFC</th>
            <th>RAZON SOCIAL </th>
            <th>CODIGO POSTAL</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let val of alumnos.personas_rfcs; let xi = index">
            <td>{{ xi + 1 }}</td>
            <td>
              <div class="field">
                <div class="b-checkbox is-info">
                  <input id="rfc_cambio{{xi}}" class="styled" (click)="cambiar_rfc(val)" type="checkbox" [checked]="val.rfc == alumnos.factura_rfc.rfc ? true : false" />
                  <label for="rfc_cambio{{xi}}">{{ val.rfc }}</label>
                </div>
              </div>
            </td>
            <td>{{ val.razon_social }}</td>
            <td>{{ val.codigo_postal }}</td>
          </tr>
        </tbody>
      </table>

    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('cambiar_rfc')">Ok</a>
    </footer>
  </div>
</div>



<!-- ////////////////////////////////////////////////////// Facturacion /////////////////-->
<div class="modal" id="verPdf">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:80%">
    <header class="modal-card-head">
      <div class="modal-card-title">
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <p class="subtitle is-5">
                <strong>Facturación {{facturacion.Version}} </strong>
              </p>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right">
            <p class="level-item">
              <a class=" navbar-item tooltip" id="imprimir_pdf" (click)="ctrl.imprimeFactura(facturacion, logo)">
                <span class="icon fa-2x">
                  <i class="icon-printer2"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir</span>
              </a>

              <button class="navbar-item is-success tooltip" (click)="ctrl.abrirModal('confirmarTimbrar')" [disabled]="cargando"
                *ngIf="valido">
                <span class="icon fa-2x has-text-black">
                  <i class="fa fa-qrcode"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Timbrar</span>
              </button>

              <a class=" navbar-item"></a>
            </p>
          </div>
        </nav>
      </div>
      <button class="delete" (click)="ctrl.cancelarModal('verPdf')"></button>
    </header>
    <section class="modal-card-body" *ngIf="facturacion_inicio">

      <div class="box">
        <article class="media">
          <div class="media-content">
            <section class="hero is-primary">
              <div class="hero-body">
                <nav class="level">
                  <div class="columns">
                    <div class="column is-9">
                      Uso CFDI:
                      <div class="select" style="float:right">
                        <select class="select" [(ngModel)]="facturacion.Receptor.UsoCFDI" [ngModelOptions]="{standalone: true}">
                          <option *ngFor="let item of ctrl.catalogos_usos_cfdis" value="{{item.clave}}">{{item.nombre}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="column is-6">
                      Impuestos:
                      <hr style="border: none; margin: 0.5rem 0; height: 0px;">
                      <div class="b-checkbox is-large" style="float:left">
                        <input id="seleccionar_iva" class="styled" type="checkbox" [(ngModel)]="seleccionar_iva" [ngModelOptions]="{standalone: true}">
                        <label for="seleccionar_iva">
                          {{seleccionar_iva ? 'Seleccionar productos con iva' : 'Todos los productos con iva'}}
                        </label>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </section>

            <div class="notification is-danger" *ngIf="error_timbre">
              ¡Ocurrio un error al intentar timbrar la factura!
              <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-danger" *ngIf="error_busqueda">
              ¡Ocurrio un error al intentar buscar!
              <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-black" *ngIf="sin_resultado != ''">
              ¡Mesaje del servidor!
              <strong>{{sin_resultado}}</strong>
            </div>
            <div *ngIf="errores.length > 0">
              <div class="notification is-danger" *ngFor="let msg of errores;">
                <font size="6pt">{{msg.codigo}}</font> {{msg.mensaje}}
                <strong>{{msg.fecha | formatoFecha}}</strong>
              </div>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
              <br>
              <span class="tag is-primary is-large ">
                <span class="icon">
                  <i class="icon-worldwide fa-spin"></i>
                </span> &nbsp;
                <span>Cargando...</span>
              </span>
              <br>
              <br>
            </div>
            <br>
            <div id="imprimir_factura">
              <article class="media">
                <div class="media-content">
                  <div>
                    <!-- emisor -->
                    <div class="columns">
                      <div class="column is-2">
                        <figure class="image is-1by1 figure-border logo">
                          <img [src]="ctrl.configuracion.sucursal.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.sucursal.logo : ctrl.configuracion.empresa.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.empresa.logo : './assets/yoursoft.png'">
                        </figure>
                      </div>

                      <div class="column is-6">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Folio fiscal: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.UUID}}
                                </p>
                                <p>
                                  <strong>No. de serie del CSD: </strong>
                                  {{facturacion.NoCertificado}}
                                </p>
                                <p>
                                  <strong>No. de serie del certificado SAT: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.NoCertificadoSAT}}
                                </p>
                                <p>
                                  <strong>Fecha y hora de emisión: </strong>
                                  {{facturacion.Fecha }}
                                </p>
                                <p>
                                  <strong>Fecha y hora de certificación: </strong>
                                  {{facturacion.Complemento.TimbreFiscalDigital.FechaTimbrado}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>

                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Emisor: </strong>
                                  {{facturacion.Emisor.Nombre}}
                                </p>
                                <p>
                                  <strong>R.F.C.: </strong>
                                  {{facturacion.Emisor.Rfc}}
                                </p>
                                <p>
                                  <strong>Lugar de expedición: </strong>
                                  {{facturacion.LugarExpedicion}}
                                </p>
                                <p>
                                  <strong>Régimen fiscal: </strong>
                                  {{facturacion.Emisor.RegimenFiscal}}
                                </p>
                                <p>
                                  <strong>Tipo de comprobante: </strong>
                                  {{facturacion.TipoDeComprobante}}
                                </p>

                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- datos del cliente -->
                    <div class="columns">
                      <div class="column is-8">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Receptor:</strong>
                                  {{facturacion.Receptor.Nombre}}
                                </p>
                                <p>
                                  <strong>R.F.C.:</strong>
                                  {{facturacion.Receptor.Rfc}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Uso CFDI:</strong>
                                  {{facturacion.Receptor.UsoCFDI}}
                                </p>
                                <p>
                                  <strong>Folio y serie:</strong>
                                  {{facturacion.Folio}} {{facturacion.Serie}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- complemento educativo -->
                    <div class="columns" *ngIf="facturacion.Conceptos.Concepto.length > 0 ">
                      <div class="column is-12">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <table class="table is-striped  is-fullwidth">
                                  <thead>
                                    <tr>
                                      <th>IEDU Versión</th>
                                      <th>Alumno </th>
                                      <th>CURP </th>
                                      <th>Nivel</th>
                                      <th>RVOE </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.version}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nombreAlumno}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.CURP}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo}}</td>
                                      <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.autRVOE}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>

                    <!-- detalle de los articulos -->
                    <div class="columns">
                      <div class="column is-12">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <table class="table is-striped  is-fullwidth">
                                  <thead>
                                    <tr>
                                      <th>Cve prod/serv </th>
                                      <th>No. Identificacion </th>
                                      <th>Cantidad </th>
                                      <th>Unidad</th>
                                      <th>Descripción </th>
                                      <th>Precio </th>
                                      <th>Descuento </th>
                                      <th>Impuesto </th>
                                      <th>Importe </th>
                                      <th *ngIf="seleccionar_iva" class="novisible">IVA?</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let concepto of facturacion.Conceptos.Concepto; let i = index">
                                      <td>{{concepto.ClaveProdServ}}</td>
                                      <td>{{concepto.NoIdentificacion}}</td>
                                      <td>{{concepto.Cantidad}}</td>
                                      <td>{{concepto.ClaveUnidad}} {{concepto.Unidad}}</td>
                                      <td>{{concepto.Descripcion}}</td>
                                      <td>{{concepto.ValorUnitario | currency:ctrl.configuracion.sucursal.moneda}} </td>
                                      <td>{{concepto.Descuento | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                      <td>
                                        <span *ngIf="concepto.Impuestos">
                                            <small *ngIf="concepto.Impuestos.Traslados.length > 0">Traslados</small>
                                            <span *ngFor="let traslado of concepto.Impuestos.Traslados">
                                                <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                                    == 'Tasa' || traslado.Traslado.TipoFactor
                                                    == '1' ? (traslado.Traslado.TasaOCuota
                                                    * 100) + '%' : (traslado.Traslado.TipoFactor == '3' ? 'Excento' : traslado.Traslado.TipoFactor)}}):
                                                </strong>
                                                {{ traslado.Traslado.TipoFactor == 'Tasa' || traslado.Traslado.TipoFactor
                                                == '1' ? (traslado.Traslado.Importe  | currency:ctrl.configuracion.sucursal.moneda) : ''}}
                                            </span>
                                        </span>

                                        <span *ngIf="concepto.Impuestos">
                                            <small *ngIf="concepto.Impuestos.Retenciones.length > 0">Retenciones</small>
                                            <span *ngFor="let retencion of concepto.Impuestos.Retenciones">
                                                <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                                    == 'Tasa' || retencion.Retencion.TipoFactor
                                                    == '1' ? (retencion.Retencion.TasaOCuota
                                                    * 100) + '%' : (retencion.Retencion.TipoFactor == '3' ? 'Excento' : retencion.Retencion.TipoFactor )}}):</strong>
                                                {{ traslado.Retencion.TipoFactor == 'Tasa' || traslado.Retencion.TipoFactor
                                                == '1' ? (retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda) : ''}}
                                            </span>
                                        </span>
                                    </td>
                                      <td>{{concepto.Importe | currency:ctrl.configuracion.sucursal.moneda}}</td>
                                      <td class="novisible" *ngIf="seleccionar_iva">
                                        <div class="b-checkbox is-large">
                                          <input id="con_iva{{i}}" class="styled" type="checkbox" [(ngModel)]="concepto.iva" [ngModelOptions]="{standalone: true}"
                                            (click)="quita_poner_iva(concepto)" (checked)="concepto.iva ? true: false">
                                          <label for="con_iva{{i}}">

                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>

                                </table>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <!-- pago -->
                    <div class="columns">
                      <div class="column is-8">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <div>
                                  <strong>Total con letra</strong>
                                  {{facturacion.Total | numeroLetra:configuracion.sucursal.moneda}}
                                  <hr class="hr">
                                </div>
                                <div class="columns">
                                  <div class="column is-6">
                                    <p>
                                      <strong>Moneda:</strong>
                                      {{facturacion.Moneda}}
                                    </p>
                                    <p>
                                      <strong>Forma de pago:</strong>
                                      {{facturacion.FormaPago}}
                                    </p>
                                  </div>
                                  <div class="column is-6">
                                    <p>
                                      <strong>Método de pago:</strong>
                                      {{facturacion.MetodoPago}}
                                    </p>
                                    <p>
                                      <strong>Condiciones de pago:</strong>
                                      <span class="sellos_sat" style="word-wrap: break-word; font-size:9pt;">
                                        {{facturacion.CondicionesDePago}}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div class="column is-4">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content">
                                <p>
                                  <strong>Subtotal:</strong>
                                  {{facturacion.SubTotal | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                                <p>
                                  <strong>Descuento:</strong>
                                  {{facturacion.Descuento | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">

                                  <small *ngIf="facturacion.Impuestos.Traslados.length > 0">Traslados</small>
                                  <p *ngFor="let traslado of facturacion.Impuestos.Traslados">
                                      <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                          == 'Tasa' || traslado.Traslado.TipoFactor
                                          == '1' ? (traslado.Traslado.TasaOCuota
                                          * 100) + '%' : (traslado.Traslado.TipoFactor == '3' ? 'Excento' : traslado.Traslado.TipoFactor)}}):
                                      </strong>
                                      {{ traslado.Traslado.TipoFactor == 'Tasa' || traslado.Traslado.TipoFactor
                                      == '1' ? (traslado.Traslado.Importe  | currency:ctrl.configuracion.sucursal.moneda) : ''}}

                                  </p>
                              </div>
                              <div class="impuestos_fac" *ngIf="facturacion.Impuestos">
                                  <small *ngIf="facturacion.Impuestos.Retenciones.length > 0">Retenciones</small>
                                  <p *ngFor="let retencion of facturacion.Impuestos.Retenciones">
                                      <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                          == 'Tasa' || retencion.Retencion.TipoFactor
                                          == '1' ? (retencion.Retencion.TasaOCuota
                                          * 100) + '%' : (retencion.Retencion.TipoFactor == '3' ? 'Excento' : retencion.Retencion.TipoFactor )}}):</strong>
                                      {{ traslado.Retencion.TipoFactor == 'Tasa' || traslado.Retencion.TipoFactor
                                      == '1' ? (retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda) : ''}}

                                  </p>
                              </div>
                                <p>
                                  <strong>Total:</strong>
                                  {{facturacion.Total | currency:ctrl.configuracion.sucursal.moneda}}
                                </p>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>

                    <!-- qy y sellos -->
                    <div class="columns">
                      <div class="column is-2">
                        <figure class="image is-1by1 figure-border">
                          <img [src]="'data:image/png;base64,' + facturacion.Complemento.TimbreFiscalDigital.qr" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr != ''">
                          <img src="assets/qr.png" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr == ''">
                        </figure>
                      </div>
                      <div class="column is-10">
                        <div class="box">
                          <article class="media">
                            <div class="media-content">
                              <div class="content sellos">
                                <div>
                                  <strong>Sello digital del CFDI:</strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.SelloCFD}}
                                  </div>
                                </div>
                                <div>
                                  <strong>Sello digital del SAT:</strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.SelloSAT}}
                                  </div>
                                </div>
                                <div>
                                  <strong>Cadena original del complemento de certificación del SAT:
                                  </strong>
                                  <br>
                                  <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                    {{facturacion.Complemento.TimbreFiscalDigital.CadenaOriginal}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                    <p align="center">
                      <strong>Este documento es una representación impresa de un CFDI versión {{VERSION_CFDI}}</strong>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </article>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a id="cerrarverPdf" class="button" (click)="ctrl.cancelarModal('verPdf')">Cancelar</a>
    </footer>
  </div>
</div>


<div class="modal" id="confirmarTimbrar">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-warning"></i> Confirmar</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarTimbrar')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de iniciar el proceso de timbrado?</h1>
        <p>Ya no se podra agregar más información a esta hoja</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="timbrar()">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarTimbrar')">Cancelar</a>
    </footer>
  </div>
</div>


<div class="modal" id="recibos">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:60%">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-credit-card"></i> Detalles del pago</p>
      <button class="delete" (click)="ctrl.cancelarModal('recibos')"></button>
    </header>
    <section class="modal-card-body">
      <p>
        <span class="tag is-medium is-link"> Importe: {{ tickets.precio | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
        <span class="tag is-medium is-warning"> Becas y cupones: {{ tickets.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
        <span class="tag is-medium is-info"> Abonado: {{ tickets.total_abonado | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
        <span class="tag is-medium is-danger"> Recargo: {{ tickets.recargo | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
        <span class="tag is-medium is-success"> Total: {{ tickets.total_abonado + tickets.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
        <span class="tag is-medium is-link"> Resta: {{ (tickets.precio + tickets.recargo) - (tickets.total_abonado + tickets.descuento) | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
      </p>

      <table class="table is-striped  is-fullwidth">
        <thead>
          <tr>
            <th># </th>
            <th>Codigo</th>
            <th>Fecha </th>
            <th>Importe</th>
            <th>Comentarios</th>
            <td>Imprimir</td>
            <td *ngIf="permisos.indexOf('PagoController.destroy') > -1">Eliminar</td>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let val of tickets.movimientos_tikets; let xi = index">
            <td>{{ xi + 1 }}</td>
            <td>{{ val.movimientos.codigo }}</td>
            <td>{{ val.movimientos.created_at }}</td>
            <td>{{ val.movimientos.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow' }}</td>
            <td>{{ val.movimientos.pagos[0].comentarios }}</td>
            <td>
              <a class="button navbar-item tooltip" (click)="ctrl.imprimeTicket(val)" style="width: 50%; float: left;">
                <span class="icon fa-2x">
                  <i class="icon-printer2"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir Ticket</span>
              </a>
              <a class="button navbar-item tooltip" (click)="enviarTicketDos(val)" style="width: 50%; float: left;">
                <span class="icon fa-2x">
                  <i class="icon-email3"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Enviar Ticket</span>
              </a>

              <a class="button navbar-item tooltip" (click)="ctrl.imprimeFactura(val.factura, logo)" *ngIf="val.factura" style="width: 50%; float: left;">
                <span class="icon fa-2x">
                  <i class="icon-print"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir Factura</span>
              </a>
            </td>

            <td *ngIf="permisos.indexOf('PagoController.destroy') > -1" style="width: 50%; float: left;">
              <a class="button navbar-item tooltip" (click)="confirmar_eliminar(val)">
                <span class="icon fa-2x has-text-danger">
                  <i class="icon-trash"></i>
                </span>
                <span class="tooltiptext is-hidden-touch">&nbsp; Eliminar</span>
              </a>
            </td>

          </tr>
        </tbody>
      </table>

    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('recibos')">Ok</a>
    </footer>
  </div>
</div>


<div class="modal" id="cancelacion">
  <div class="modal-background"></div>
  <div class="modal-card" style="width:60%">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="fa fa-credit-card"></i> Cancelar movimiento</p>
      <button class="delete" (click)="ctrl.cancelarModal('recibos')"></button>
    </header>
    <section class="modal-card-body">
      <h1 style="font-size: 1.5em; font-weight:600; ">¿Esta seguro de cancelar el movimiento?</h1>
      <h3 >Esta acción puede afectar a la caja de otro día si la fecha es diferente a la de hoy</h3>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="eliminar_ticket()">Si, estoy seguro</a>
      <a class="button" (click)="ctrl.cancelarModal('cancelacion')">Cancelar</a>
    </footer>
  </div>
</div>
